import { render, staticRenderFns } from "./StudentExamReportTable.vue?vue&type=template&id=1ba6c766&scoped=true"
import script from "./StudentExamReportTable.vue?vue&type=script&lang=js"
export * from "./StudentExamReportTable.vue?vue&type=script&lang=js"
import style0 from "./StudentExamReportTable.vue?vue&type=style&index=0&id=1ba6c766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba6c766",
  null
  
)

export default component.exports